import gql from 'graphql-tag';
import { PROJECT_FRAGMENT } from './project';

const BILLING_ACCOUNT_FRAGMENT = gql`
	fragment billingAccount on BillingAccount {
		billingaccountid
		billingaccountname
		balance
		quota
		limit
		available
		createdtime
		updatedtime
		mode
	}
`;

const QUERY_BILLING_ACCOUNT_DATA = gql`
	query _billingAccountData($billingaccountid: String) {
		billingAccount(billingaccountid: $billingaccountid) {
			...billingAccount
		}
		projectList {
			...project
		}
	}
	${BILLING_ACCOUNT_FRAGMENT}
	${PROJECT_FRAGMENT}
`;



export { QUERY_BILLING_ACCOUNT_DATA };
